import React from "react";
import submit from "submit-form";
import SvgIcon from "../../../../parts/SvgIcon";

const ManageCategories = ({
  category,
  filteredProgramsLength = 0,
  selectedCategoryIndex,
  deleteCategory,
  currentTab,
}) => {
  const nameForPrograms = {
    programs: "Programs",
    teams: "Teams",
    "single-workout": "Single Workouts",
  };

  return (
    <hgroup className="group-content">
      <div className="mobile-hidden">
        <h3>{category}</h3>
        <p className="p5">
          ({filteredProgramsLength}) {nameForPrograms[currentTab]}
        </p>
      </div>
      <div className="mobile-hidden">
        {category !== "Uncategorized" ? (
          <>
            <button
              data-button-type="secondary"
              data-icon
              onClick={() => {
                submit("/actions/refresh?", {
                  method: "GET",
                  body: {
                    "modal[type]": "manage-categories",
                    storeType: currentTab,
                  },
                });
              }}
            >
              <SvgIcon src="/img/new-icons/manage.svg" />
              Manage
            </button>
            <button
              data-button-type="secondary"
              data-action="delete"
              onClick={() => deleteCategory(selectedCategoryIndex)}
            >
              <SvgIcon
                src="/img/svg/trash-alt.svg"
                alt="delete"
                noFilterOnLight={true}
              />
              Delete Category
            </button>
          </>
        ) : null}
      </div>
    </hgroup>
  );
};

export default ManageCategories;
